import { showValidationErrorMessage } from "./showValidationErrorMessage";

export const payValidationOptions = {
  rules: {
    first_name: {
      required: true,
    },
    last_name: {
      required: true,
    },
    postcode: {
      required: true,
    },
    city: {
      required: true,
    },
    email: {
      email: true,
      required: true,
    },
    sort_code: {
      required: true,
      maxlength: 6,
      number: true,
    },
    account_number: {
      required: true,
      maxlength: 8,
      number: true,
    },
    is_authorised_direct_debit: {
      required: true,
    },
    iban: {
      required: true,
      alphanumeric: true,
    },
  },
  messages: {
    sort_code: "Please enter only numbers, no hyphens",
    is_authorised_direct_debit:
      "Please confirm you are authorised to set up Direct Debit payments on this account",
  },
  errorPlacement: showValidationErrorMessage,
};
